module.exports = __webpack_public_path__ + "static/media/bg-download-lg.175fd93f.png";